import React from "react";

import CustomFilters from "./CustomFilters";

import "./CustomList.scss";

const CustomList = (props) => {
    return (
        <div className="search-filters">
            <CustomFilters showInitial={true} />
        </div>
    );
};

export default CustomList;
